import { apiRequest } from "../apiServices";

export const loginGenerateOTP = (data) => apiRequest({ portal: "dmq", method: "post", endpoint: "/login/generate-otp", data: data });
export const loginVerifyOTP = (data) => apiRequest({ portal: "dmq", method: "post", endpoint: "/login/verify-otp", data: data });
